import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3cc78efa")
const _hoisted_1 = { class: "_main" }
const _hoisted_2 = { class: "_header" }
const _hoisted_3 = { class: "_headerBack" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "_headerText" }, " Partners ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "header" }, " Partners ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "section" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "_setting" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "_setting_header" }, "What is a partner?")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, " Our partners have us build custom games. "),
  /*#__PURE__*/_createElementVNode("ol", null, [
    /*#__PURE__*/_createElementVNode("li", null, "You tell us what you want, we build it together. "),
    /*#__PURE__*/_createElementVNode("li", null, "We customise the experience and how it's delivered."),
    /*#__PURE__*/_createElementVNode("li", null, "Distribute it to your audience.")
  ])
], -1)
const _hoisted_7 = { class: "section form" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "Want to become a partner?", -1)
const _hoisted_9 = {
  key: 0,
  class: "_setting"
}
const _hoisted_10 = {
  key: 1,
  class: "report"
}
const _hoisted_11 = { class: "text" }
const _hoisted_12 = { class: "dropdown" }
const _hoisted_13 = { class: "dropdown" }
const _hoisted_14 = { class: "dropdown" }
const _hoisted_15 = { class: "button" }
const _hoisted_16 = {
  key: 2,
  class: "reportOutcome"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Message sent")
], -1)
const _hoisted_18 = { class: "text" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Thank you for your inquiry - our team will review it at our next convenience and get back to you. ")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "_footer _card" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Advisory"),
  /*#__PURE__*/_createElementVNode("p", null, " We are a small team that is dedicated to producing high quality experiences for our users. Our prices are very affordable and negotiable. Please note, our team only speaks English, so games in other languages may be unachievable. ")
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_TextArea = _resolveComponent("TextArea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_IconButton, {
          icon: "back",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({path:'/app'}))),
          white: true
        })
      ]),
      _hoisted_4
    ]),
    _hoisted_5,
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      (_ctx.reportSendError)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_9, " Error: " + _toDisplayString(_ctx.reportSendError), 1))
        : _createCommentVNode("", true),
      (!_ctx.reportSendSuccess)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_Dropdown, {
                  white: true,
                  options: _ctx.reportType,
                  onUpdate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reportType.active=$event)),
                  label: "I represent"
                }, null, 8, ["options"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_TextInput, {
                  default: _ctx.reportName,
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.reportName = $event)),
                  label: "Name"
                }, null, 8, ["default"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_TextInput, {
                  default: _ctx.reportEmail,
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.reportEmail = $event)),
                  label: "Email"
                }, null, 8, ["default"])
              ]),
              _createVNode(_component_TextArea, {
                default: _ctx.reportText,
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.reportText = $event)),
                label: "How can we help?"
              }, null, 8, ["default"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              (_ctx.sendingReport)
                ? (_openBlock(), _createBlock(_component_IconButton, {
                    key: 0,
                    icon: "loader_spinner",
                    autoplay: true,
                    loop: true,
                    text: "Sending"
                  }))
                : (_openBlock(), _createBlock(_component_IconButton, {
                    key: 1,
                    icon: _ctx.reportSendSuccess?'tick':_ctx.reportSendError?'cross':'',
                    autoplay: true,
                    text: "Send inquiry",
                    onClick: _ctx.sendReport
                  }, null, 8, ["icon", "onClick"]))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("h4", null, " Name: " + _toDisplayString(_ctx.reportName), 1),
              _createElementVNode("p", null, " I represent: " + _toDisplayString(_ctx.reportType.options[_ctx.reportType.active].text), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.reportText), 1)
            ]),
            _hoisted_19
          ]))
    ]),
    _hoisted_20
  ]))
}